import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  IonButton,
  IonCol,
  IonIcon,
  IonRow,
} from '@ionic/angular/standalone';
import { map, take } from 'rxjs';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { UserRoles } from 'src/app/core/enums';
import {
  HomeMessage,
  MESSAGE_TYPE,
} from 'src/app/core/models/home/message.model';
import { HomeMessageService } from 'src/app/core/services/home/home-message.service';
import { UserService } from 'src/app/core/services/user/user.service';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { EditMessageModalComponent } from './edit-message-modal/edit-message-modal.component';
import { HomeCardComponent } from './home-card/home-card.component';
import {
  CARD_TEXT,
  DISPLAY_CONSTS,
  MOBILE_USER_GUIDE_PDF,
  WEB_USER_GUIDE_PDF,
} from './home.constants';
import { MessageCardComponent } from './message-card/message-card.component';

@Component({
  selector: 'app-home',
  imports: [
    IonRow,
    IonCol,
    IonButton,
    IonIcon,
    MessageCardComponent,
    HomeCardComponent,
    AsyncPipe,
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  userService = inject(UserService);
  private readonly commonUtils = inject(CommonUtils);
  private readonly homeService = inject(HomeMessageService);
  private readonly dialog = inject(MatDialog);

  readonly DISPLAY = DISPLAY_CONSTS;
  readonly CARD_TEXT = CARD_TEXT;
  readonly SRC = IMAGE_SRC;
  readonly MESSAGE_TYPE = MESSAGE_TYPE;
  readonly USER_ROLE = UserRoles;

  messages: HomeMessage[] = [];

  ngOnInit(): void {
    this.userService.getCurrentUser$;
    // this.loadMessages();
  }

  loadMessages() {
    this.homeService
      .getCurrentMessages()
      .pipe(
        map((val) => {
          this.messages = val?.response?.messages ?? [];
        }),
      )
      .subscribe();
  }

  addMessage() {
    this.dialog
      .open(EditMessageModalComponent, {
        disableClose: true,
        width: '32vw',
        data: {
          edit: false,
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((value) => {
        if (value) {
          this.loadMessages();
        }
      });
  }

  buttonClick(i: number) {
    switch (i) {
      case 0:
        this.commonUtils.convertBase64toPdf(
          MOBILE_USER_GUIDE_PDF,
          'GPD_Mobile_Guide',
        );
        break;
      case 1:
        this.commonUtils.convertBase64toPdf(WEB_USER_GUIDE_PDF, 'GPD_Guide');
        break;
      case 2:
        const nonUrgentAnchor = document.createElement('a');
        nonUrgentAnchor.href = 'mailto:UPSTundraTeam@ups.com';
        nonUrgentAnchor.click();
        nonUrgentAnchor.remove();
        break;
      case 3:
        const urgentAnchor = document.createElement('a');
        urgentAnchor.href =
          'https://upsprod.service-now.com/sp?id=kb_article&sysparm_article=kb0014954';
        urgentAnchor.target = '_blank';
        urgentAnchor.click();
        urgentAnchor.remove();
        break;
    }
  }
}
